module.exports = __webpack_public_path__ + "static/media/add-icon.94b7c79f.svg";